<template>
  <div class="code-scanner">
    <p class="code-title"><span>扫一扫</span></p>
    <div @click="expired&&getWXImg()">
      <div class="code">
        <i class="el-icon-refresh" v-if="expired"></i>
        <img :src="code.qr_url" width="238px" :class="{expired:expired}">
      </div>
      <p class="tips">
        <span v-if="!expired">请使用微信扫码</span>
        <span v-else><i class="el-icon-warning"></i>点击刷新</span>
      </p>
    </div>
  </div>
</template>

<script>
  import apis from "@/api/apis";
  import auth from "@/utils/auth";

  export default {
    name: "ScannerCodeLogin",
    data() {
      return {
        code: {
          login_id: '',
          qr_url: '',
        },
        expired: false, // 二维码是否过期
        timeOutHandle: null
      }
    },
    mounted() {
      this.getWXImg()
    },
    methods: {
      checkLogin() {
        apis.register.checkQrLogin({login_id: this.code.login_id}).then(res => {
          if (res.data !== null) {
            if (res.data.page === 'login') { // 已扫码并且已绑定过的用户，直接去登录
              // 直接登录
              apis.register.checkUser({
                login_id: res.data.login_id,
                openid: res.data.openid,
              }).then(result => {
                auth.saveUser(result.data.userinfo)
                auth.saveToken(result.data.userinfo.token)
                auth.saveSkey(result.data.security_key)
                this.$emit('loginSuccess')
              })
            } else if (res.data.page === 'bind') { // 需要绑定手机号
              this.$emit('bindMobile', res.data.login_id, res.data.openid)
            } else if (res.data.page === 'reset') { // 二维码过期
              this.expired = true
            }
          } else {
            this.timeOutHandle = setTimeout(() => {
              this.checkLogin()
            }, 4000)
          }
        })
      },
      // 微信二维码
      getWXImg() {
        apis.register.getQrCode().then(res => {
          this.code.login_id = res.data.login_id
          this.code.qr_url = res.data.qr_url
          this.expired = false
          this.checkLogin()
        })
      },
    },
    destroyed() {
      clearTimeout(this.timeOutHandle)
    }
  }
</script>

<style scoped lang="scss">
  .code-scanner {
    padding: 31px 56px;
    text-align: center;

    .code-title {
      font-size: 24px;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.85);
      line-height: 33px;
      text-align: center;
    }

    .code {
      width: 240px;
      height: 240px;
      margin: 48px auto 30px;
      border-radius: 4px;
      border: 1px solid rgba(0, 0, 0, 0.1);
      position: relative;
      img.expired {
          opacity: 0.2;
        cursor: pointer;
        }
      }
    .el-icon-refresh{
      position: absolute;top: 105px;left: 105px;font-size: 30px;
    }
  }
</style>